// Split label + suffix rendering for TagChip (name truncates, suffix stays visible).
import { Box } from '@mui/material';
import { tagChipNameMaxWidthCh } from '@/components/ui/tagChipTruncate';

export function TagChipLabelContent({ text, labelSuffix, dense }) {
  if (!labelSuffix) return text;
  const nameMax = tagChipNameMaxWidthCh(dense);
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        minWidth: 0,
        maxWidth: '100%',
      }}
    >
      <Box
        component="span"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: nameMax,
        }}
      >
        {text}
      </Box>
      <Box component="span" sx={{ flexShrink: 0 }}>
        {labelSuffix}
      </Box>
    </Box>
  );
}
